<template>
  <img :height="height" :width="width" :src="spinnerUrl" alt="loading" />
</template>

<script>
/* disable-eslint */
import spinner from "../../Mixins/spinner.js";

export default {
  mixins: [spinner]
};
</script>

<style></style>
